module.exports = __webpack_public_path__ + "static/img/logo_shsnykxy.a76137b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_shsnykxy.png
// module id = 8U7N
// module chunks = 15